<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <PopupIntroCModal
        :response="content"
        :preTestScore="preTestScore"
        :isAddQueueShow="true"
        :CheckWidth="CheckWidth"
        :checkAnswer="checkAnswer"
        :point="point"
        :checkText="checkText"
      />
    </template>
  </div>
</template>
<script>
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import { mapGetters } from "vuex";
import PopupIntroCModal from "../../components/template/Chinese1/PopupIntroCModal";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { PopupIntroCModal,LoadingMDL },
  name: "LKT01",
  data() {
    return {
      point: null,
      code: "",
      lang: "",
      content: {},
      checkAnswer: null,
      CheckWidth: window.innerWidth.toString(),
      preTestScore: null,
      courseSection: "",
      startTime: "",
      courseCode: "",
      result: {},
      checkText: false,
      loading:true
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getCheckAnswerResult: "template/getCheckAnswerResult",
      isTestOpen: "template/getTestStatus",
    }),
  },

  watch: {
    isTestOpen: function(val) {
      if (val == false) {
        this.$router.push("/HP01/1");
      }
    },
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });

        if (val.codeTemplate === "LKT01-42") {
        }
        if (val.codeTemplate === "LKT01-80") {
          this.checkAnswer = true;
        }
        this.loading = false;
      }
    },
    getCheckAnswerResult: function(val) {
      if (val.userAnswer.length > 0) {
        this.checkAnswer = val.userAnswer[0].status;
      }
      this.loading = false;
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = "LKT01-" + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.lang = this.$store.state.language.language;
    this.pageCode = `LKT01-` + this.$route.params.id;
    if (this.pageCode === "LKT01-77") {
      let score = this.$store.getters["template/getDisplayScore"]
        .totalQuizScore;
      this.preTestScore = score;
    }

    if (
      this.pageCode === "LKT01-24" ||
      this.pageCode == "LKT01-65" ||
      this.pageCode == "LKT01-66"
    ) {
      this.point = this.$store.getters["necessary/getTmpScore"];
    }
    if (this.pageCode == "LKT01-65" || this.pageCode == "LKT01-66") {
      this.checkText = true;
    }
    if (this.pageCode === "LKT01-78") {
      this.$store.commit("necessary/setMode", { mode: true, type: "POSTTEST" });
    }

    let result = this.$store.getters["template/getCheckAnswerResult"];
    if (result == undefined || result.userAnswer == undefined) {
      this.checkAnswer = this.$store.getters["template/getCheckingResult"];
    } else {
      if (result.userAnswer.length == 0) {
        this.checkAnswer = this.$store.getters["template/getCheckingResult"];
      } else {
        this.checkAnswer = result.userAnswer[0].status;
      }
    }

    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    // this.checkAnswer = result;
    let body = {};
    body.code = this.courseCode;
    body.templateCode = this.pageCode;
    this.$store.dispatch("template/fetchContent", body);
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },

    funcRoute(val) {
      let payload = {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      }
      console.log("payload",payload);
      this.$store.dispatch("template/saveUserTemplateData",payload );
      
      if (typeof val === "string") {
        this.nextAction = this.$helpers.setChineseUrl(val);
      } else {
        this.$store.commit("necessary/setCodePage", val[1]);
        this.nextAction = "/" + val[0] + "/" + val[1];
      }
    },

  },
};
</script>
<style></style>
